const BASE_ADMIN = {
  id: '99999',
  firstName: 'Emily',
  lastName: 'Carr',
  fullName: 'Emily Carr',
  email: 'emily.carr@example.edu.ca',
  emailStatus: 'VERIFIED',
  locale: 'en-us',
  // all purchasers (districts and child schools) within scope of this admin user
  purchaserIds: [
    '10000',
    '10002',
    '10003',
    '10010',
    '10011',
    '11000',
    '12000',
    '12001',
    '12002',
    '12003',
    '12005',
    '12006',
  ],
  // only the districts or individual schools directly managed by this admin user
  managedPurchaserIds: ['10000', '10010', '11000', '12000'],
};

export default [
  // The default "current user" administrator
  // In dev and test mode, sign-in using any username and password.
  BASE_ADMIN,
  // The "current user" administrator, in Norwegian.
  // In dev and test mode, sign-in using `nb` for the username and any password.
  {
    ...BASE_ADMIN,
    id: '99998',
    firstName: 'Magnus',
    lastName: 'Carlsen',
    fullName: 'Magnus Carlsen',
    email: 'magnus.carlsen@chess.edu.com',
    emailStatus: 'VERIFIED',
    locale: 'nb',
    picturePath: '/assets/test-fixtures/carlsen-2.png',
    largePicturePath: '/assets/test-fixtures/carlsen-2.png',
  },
  // The "current user" administrator, in Swedish.
  // In dev and test mode, sign-in using `sv` for the username and any password.
  {
    ...BASE_ADMIN,
    id: '99997',
    firstName: 'Agnetha',
    lastName: 'Fältskog',
    fullName: 'Agnetha Fältskog',
    email: 'agnetha.fältskog@abba.example.sv',
    locale: 'sv',
    picturePath: '/assets/test-fixtures/agnetha-fältskog.jpg',
    largePicturePath: '/assets/test-fixtures/agnetha-fältskog.jpg',
  },
  // The "current user" administrator, in German.
  // In dev and test mode, sign-in using `de` for the username and any password.
  {
    ...BASE_ADMIN,
    id: '99996',
    firstName: 'Christa',
    lastName: 'Päffgen',
    fullName: 'Christa Päffgen (Nico)',
    email: 'christa.päffgen@nico.example.de',
    locale: 'de',
    picturePath: '/assets/test-fixtures/christa-päffgen.jpg',
    largePicturePath: '/assets/test-fixtures/christa-päffgen.jpg',
  },
  // The "current user" administrator, in Danish.
  // In dev and test mode, sign-in using `da` for the username and any password.
  {
    ...BASE_ADMIN,
    id: '99995',
    firstName: 'Agnes',
    lastName: 'Obel',
    fullName: 'Agnes Obel',
    email: 'agnes.obel@example.da',
    locale: 'da',
  },
  {
    id: '200800',
    fullName: 'Dean Pelton',
    firstName: 'Craig',
    lastName: 'Pelton',
    picturePath: '/assets/test-fixtures/Craig_Pelton.webp',
    email: 'c.pelton@greendale.edu.test',
    emailStatus: 'VERIFIED',
    managedPurchaserIds: ['10002'],
  },
  {
    id: '200801',
    fullName: 'Vice-Dean Laybourne',
    firstName: 'Robert',
    lastName: 'Laybourne',
    picturePath: '/assets/test-fixtures/Laybourne.webp',
    email: 'r.laybourne@greendale.edu.test',
    emailStatus: 'VERIFIED',
    managedPurchaserIds: ['10002'],
  },
  {
    id: '200851',
    fullName: 'Stephen Spreck',
    firstName: 'Stephen',
    lastName: 'Spreck',
    email: 's.spreck@city-college.edu.test',
    emailStatus: 'VERIFIED',
    managedPurchaserIds: ['10003'],
  },
  {
    id: '200200',
    fullName: 'The Shadowy Figure',
    firstName: 'The Secret',
    lastName: 'Board of Shadowy Figures',
    email: 'tsbosf@clone.high.edu.test',
    emailStatus: 'VERIFIED',
    managedPurchaserIds: ['11000'],
  },
];
